export const zipCodeMask = (value: string) =>
  value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})+?$/, '$1-$2');

export const documentNumberMask = (value: string) => {
  const newValue = value.replace(/\D/g, '');
  if (newValue.length > 11) {
    return newValue
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\/\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  } else {
    return newValue
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  }
};

export const phoneMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/g, '($1) $2')
    .replace(/(\d)(\d{4})$/, '$1-$2');

export const numbersMask = (value: string) => {
  // Remove any non-numeric characters except digits and commas
  value = value.replace(/[^\d,]/g, '');

  // Ensure only one comma is present
  const parts = value.split(',');
  if (parts.length > 2) {
    value = `${parts[0]},${parts[1]}`;
  }

  // Prevent multiple leading zeros
  value = value.replace(/^0+(?=\d)/, '');

  return value;
};
// value.replace(/[^0-9,]/g, '');

export const lettersMask = (value: string) =>
  value.replace(/[0-9!@#¨$%^&*)(+=._-]+/g, '');

export const birthDateMask = (value: string) => {
  const newValue = value.replace(/\D/g, '').slice(0, 8);
  if (newValue.length >= 5) {
    return `${newValue.slice(0, 2)}/${newValue.slice(2, 4)}/${newValue.slice(
      4
    )}`;
  } else if (newValue.length >= 3) {
    return `${newValue.slice(0, 2)}/${newValue.slice(2)}`;
  }
  return newValue;
};
